// import { firestoreAction } from 'vuexfire'
import { db } from '@/globals'

// initial state
const state = () => ({
  errors: [],
  errorsTriggeringIntercom: [] // errors with 'triggersIntercom' tag
})

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  collectError(state, payload) {
    state.errors.push(payload.error)
    if (payload.error.tags && payload.error.tags.includes('triggersIntercom')) {
      state.errorsTriggeringIntercom.push(payload.error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}